<template>
  <div class="accordion">
    <div
      class="accordion-toggle"
      :ref="`accToggle_${id}`"
      @click="toggleAccordion"
    >
      <slot name="header">
        <span>Accordion</span>
      </slot>
      <span class="accordion-toggle-icon" :ref="`accIcon_${id}`">
        <FontAwesomeIcon :icon="['far', 'chevron-down']" />
      </span>
    </div>
    <div class="accordion-content" :ref="`accContent_${id}`">
      <div class="accordion-content-inner">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faChevronDown);

let id = 0;

export default {
  name: "Accordion",
  components: {
    FontAwesomeIcon,
  },
  methods: {
    toggleAccordion() {
      const accToggle = this.$refs[`accToggle_${this.id}`];
      const accContent = this.$refs[`accContent_${this.id}`];
      const accIcon = this.$refs[`accIcon_${this.id}`];

      accContent.classList.toggle("acordion-show");
      if (accContent.style.maxHeight) {
        accContent.style.maxHeight = null;
        accToggle.classList.remove("show");
        accIcon.classList.remove("show");
      } else {
        accContent.style.maxHeight = accContent.scrollHeight + "px";
        accToggle.classList.add("show");
        accIcon.classList.add("show");
      }
    },
  },
  beforeCreate() {
    this.id = id.toString();
    id += 1;
  },
};
</script>

<style lang="scss">
@import "../../style_variables/_typography_classes.scss";
@import "../../style_variables/style_variables.scss";
$open_sans: "Open Sans", sans-serif;

.accordion {
  background-color: $white;
  border: 1px solid $grey_french;
  border-radius: 6px;
  font-family: $open_sans;

  &-toggle {
    padding: 20px 16px;
    border-radius: 6px;
    display: flex;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    width: 100%;
    transition: 0.4s;
    &.show {
      background-color: $grey_alabaster;
    }
    &-icon {
      transition: transform 0.2s ease-out;
      &.show {
        transform: rotate(180deg);
      }
    }
  }
  &-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease-out;
    &-inner {
      padding: 16px;
    }
  }
}
</style>
